import http from '@/utils/http'

export function getTopics(params){
    return http.get('/topics',{params})
}
export function getTopicPractiseList(params){
    return http.get('/topicPractiseList',{params})
}
export function addTopics(data){
    return http.post('/topics',data)
}
export function getTopicsDetail(id){
    return http.get(`/topics/${id}`)
}
export function putTopics(id,data){
    return http.put(`/topics/${id}`,data)
}
export function deleteTopics(id){
    return http.delete(`/topics/${id}`)
}

export function gettopicsDistributionRequest(id,data){
    return http.post(`/topics/${id}/distribution_request`,data)
}

export function getTopicsTest(id) {
    return http(`/topics/${id}/small_test`)
}